import { render, staticRenderFns } from "./addDictData.vue?vue&type=template&id=4edf0f14&scoped=true"
import script from "./addDictData.vue?vue&type=script&lang=js"
export * from "./addDictData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edf0f14",
  null
  
)

export default component.exports